// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const onboardingClient = createTypedClient();
export const createOnboardingClient = (config) => createTypedClient(config);
